import * as React from "react";
import { VacuumCategoryInfo } from "../vacuum";
import { AirMeltCategoryInfo } from "../air-melt";
import { Chip } from "@mui/material";

require('./styles.scss');

interface AccordionCategoryPreviewUIProps {
  accordionSectionExpanded: boolean;
  categoriesToPreview: VacuumCategoryInfo[] | AirMeltCategoryInfo[];
}

export class AccordionCategoryPreviewUI extends React.PureComponent<
AccordionCategoryPreviewUIProps,
  {}
> {
  render() {
    const chipValues: string[] = [];
    this.props.categoriesToPreview.forEach(cat => {
      if (cat.selected === true) {
        chipValues.push(cat.value);
      }
    })

    let chipDivLen = 0;
    let notDisplayedCount = 0;
    const chipDivs: any = [];
   
    chipValues.forEach((chip, index) => {
      if (chipDivLen + chip.length < 40) {
        chipDivLen = chipDivLen + chip.length;
        chipDivs.push(<Chip key={index} size="small" label={chip}/>);
      } else {
        notDisplayedCount++;
      }
    })

    if (notDisplayedCount > 0) {
      chipDivs.push(<Chip key="extra" size="small" label={"+" + notDisplayedCount}/>); 
    }

    // keep track of number of characters
    if (this.props.accordionSectionExpanded === true) {
      return null;
    } else {
      return (
        <div className="preview-autocomplete">
          {chipDivs} 
        </div>
      );
    }
  }
}

interface AccordionNamePreviewUIProps {
  accordionSectionExpanded: boolean;
  namesToPreview: string[];
}

export class AccordionNamePreviewUI extends React.PureComponent<
AccordionNamePreviewUIProps,
  {}
> {
  render() {
    const totalLength = 30;

    let chipDivLen = 0;
    let notDisplayedCount = 0;
    const chipDivs: any = [];
   
    this.props.namesToPreview.forEach((name, index) => {
      if (chipDivLen + name.length < totalLength) {
        chipDivLen = chipDivLen + name.length;
        chipDivs.push(<Chip key={index} size="small" label={name}/>);
      } else {
        notDisplayedCount++;
      }
    })

    if (notDisplayedCount > 0) {
      chipDivs.push(<Chip key="extra" size="small" label={"+" + notDisplayedCount}/>); 
    }

    // keep track of number of characters
    if (this.props.accordionSectionExpanded === true) {
      return null;
    } else {
      return (
        <div className="preview-autocomplete">
          {chipDivs} 
        </div>
      );
    }
  }
}

export interface AccordionCompPreview {
  elemName: string;
  elemMin: number;
  elemMax: number;
  filterSet: boolean;
}

interface AccordionCompositionPreviewUIProps {
  accordionSectionExpanded: boolean;
  compositionToPreview: AccordionCompPreview[];
}

export class AccordionCompositionPreviewUI extends React.PureComponent<
AccordionCompositionPreviewUIProps,
  {}
> {
  render() {
    const totalLength = 45;

    let chipDivLen = 0;
    let notDisplayedCount = 0;
    const chipDivs: any = [];

    this.props.compositionToPreview.forEach((comp, index) => {
      if (comp.filterSet) {
        const label = comp.elemName + ": " + comp.elemMin + "-" + comp.elemMax;
        if (chipDivLen + label.length < totalLength) {
          chipDivLen = chipDivLen + label.length;
          chipDivs.push(<Chip key={index} size="small" label={label}/>)
        } else {
          notDisplayedCount++;
        }
      }
    });
   
    if (notDisplayedCount > 0) {
      chipDivs.push(<Chip key="extra" size="small" label={"+" + notDisplayedCount}/>); 
    }

    if (this.props.accordionSectionExpanded === true) {
      return null;
    } else {
      return (
        <div className="preview-autocomplete">
          {chipDivs} 
        </div>
      );
    }
  }
}